import { Box } from "@mui/material";
import { logout } from "actions/AppActions";
import { Show } from "actions/SnackbarActions";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

const UserInfo = ({ course, user, font_color, accent_color }) => {
  const dispatch = useDispatch();

  const history = useHistory();

  const Logout = useCallback(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    dispatch(logout());

    dispatch(
      Show({
        show: true,
        severity: "success",
        message: "Deslogado com sucesso! Faça login novamente.",
      })
    );

    setTimeout(() => {
      history.push("/login");
    }, 500);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        gap: "2vw",
        alignItems: "center",
      }}
    >
      <Box
        component={"img"}
        src="https://picsum.photos/200/300"
        alt="Usuário"
        sx={{
          objectFit: "cover",
          height: {
            xs: "5rem",
            sm: "7rem",
          },
          aspectRatio: "1/1",
          display: "inline-block",
          borderRadius: "50%",
        }}
      />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          color: font_color,
        }}
      >
        <h4
          style={{
            color: font_color,
          }}
        >
          {user?.name}
        </h4>
        <p>{user?.email}</p>
        <a
          href="#"
          onClick={Logout}
          style={{
            color: accent_color,
          }}
        >
          Não é você? Sair
        </a>
      </div>
    </div>
  );
};

export default UserInfo;
